import {FETCH_VACANCY_REQUEST, FETCH_VACANCY_SUCCES, FETCH_VACANCY_ERROR} from '../constants/Vacancy'
import { jsonGet, errorHandler } from '../utils/Request';

const loadVacancy = id => (dispatch) => {
  const apiUrl = '/vacancy/' + id;
  const apiUrlUuid = '/vacancy/uuid/' + id;
  dispatch({
    type: FETCH_VACANCY_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_VACANCY_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      return jsonGet(apiUrlUuid)
        .then(json => {
          dispatch({
            type: FETCH_VACANCY_SUCCES,
            payload: json,
          });
        })
    })
    .catch((e) => {
      dispatch({
        type: FETCH_VACANCY_ERROR
      });
      errorHandler(e);
    });
};

export { loadVacancy };



// WEBPACK FOOTER //
// ./src/actions/VacancyActions.js